(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const texts = document.querySelectorAll('.rotate-text');
  const rotateContainer = document.querySelector('.announcement-rotate');

  if (!texts.length) return;

  // If only ONE text → show normally (no animation)
  if (texts.length === 1) {
    texts[0].style.position = "relative";
    texts[0].style.transform = "none";
    texts[0].style.opacity = "1";
    return;
  }

  // If more than 1 → run rotation
  let index = 0;
  texts[0].classList.add('active');

  setInterval(() => {
    texts[index].classList.remove('active');
    index = (index + 1) % texts.length;
    texts[index].classList.add('active');
  }, 5000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-with-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".cfwi-section");
  if (!section) return;

  const questions = section.querySelectorAll(".cfwi-question");

  questions.forEach(btn => {
    btn.addEventListener("click", () => {
      const item = btn.closest(".cfwi-item");

      section.querySelectorAll(".cfwi-item").forEach(el => {
        if (el !== item) el.classList.remove("active");
      });

      item.classList.toggle("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fadeup-dual-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.fadeup');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  items.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
